import { VIcon, VBtn } from "vuetify/lib"
import DatePicker from '@/vuetify_custom/v-form/components/Date_Picker_v1.js'
import NumberField from '@/vuetify_custom/v-form/components/Number_Field.js'
export default {
    props: {
        value: {
            type: String
        },
        type: {
            type: String
        },
        target: {
            type: Object,
        },
        valueDis: {
            type: Function,
        },
        canEdit: {
            type:Boolean
        }
    },
    data() {
        return {
            can_edit: false,
            value_proxy: {
                value:null
            },
            loading: false,
        }
    },
    render() {
        return <div>
                    {!this.can_edit && <div>
                            {this.valueDis ? this.valueDis(this.value) : (this.value || '-')}
                            {!!this.canEdit && <VIcon x-small style="cursor: pointer;" on={{
                        click: () => {
                            this.can_edit = true
                           this.value_proxy.value = this.value
                        }
                        }}>mdi-square-edit-outline</VIcon>}
                    </div>}
                   { this.can_edit && <div >
                        {this.type === 'date' && <DatePicker
                                v-model={this.value_proxy}
                                field={{
                                    label: '',
                                    key:'value',
                                }}
                            />}
                            {this.type === 'number' && <NumberField
                                v-model={this.value_proxy}
                                field={{
                                    label: '',
                                    key:'value',
                                    d_digits:2,
                                }}
                            />}
                                <div style="margin-top:-14px">
                        <VBtn 
                                depressed 
                                small 
                                color="primary" 
                                icon
                                loading={this.loading}
                                on={{
                                    click:() => {
                                        this.$emit('submit', {
                                            value: this.value_proxy.value,
                                            target: this.target,
                                            changeLoading: () => this.loading = !this.loading,
                                            closeEdit: () => this.can_edit = false
                                        })
                                    }
                                    }}>
                                        <VIcon>
                                            mdi-check-circle
                                        </VIcon>
                                    </VBtn>
                        <VBtn 
                                style="margin-left:10px;"
                                depressed 
                                small 
                                icon
                                on={{
                                    click:() => this.can_edit = false,
                                    }}>   <VIcon>
                                   mdi-minus-circle
                                </VIcon></VBtn>
                                    </div>
                                     
                    </div>}
              
                  
                </div>
    }
}